<template>
  <div>
    <b-card
      v-if="$permissionAbility(SALARY_PAYSLIP_CREATE, permissions)"
      title="Generate Payslip"
    >
      <!-- search input -->
      <validation-observer ref="generateAllAttendanceValidation">
        <b-form @submit.prevent="generateAllReport">
          <div>
            <b-row>

              <b-col
                md="3"
                lg="3"
                xs="12"
              >
                <b-form-group
                  label=""
                  label-for="empId"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="User"
                    vid="empId"
                  >
                    <v-select
                      id="empId"
                      v-model="selectEmpId"
                      name="empId"
                      :options="userIdOption"
                      :reduce="(item) => item.id"
                      label="name"
                      placeholder="Employee"
                      class="mb-1 custom-font"
                    >
                      <template #option="data">
                        <UserSelect :user="data" />
                      </template>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                lg="3"
                xs="12"
              >
                <v-select
                  v-model="selectDepartmentId"
                  :options="filterDepartmentIdOption"
                  :reduce="(item) => item.id"
                  label="name"
                  placeholder="Department"
                  class="mb-1 custom-font"
                  @input="changeDepartment"
                />
              </b-col>

              <b-col
                md="3"
                lg="2"
                xs="12"
              >
                <div
                  class="custom-search d-flex align-items-center justify-content-end"
                >
                  <div
                    class="d-flex flex-column flex-sm-row align-items-center justify-content-around"
                  >
                    <template v-if="isReportGenerating">
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        class="flex-shrink-0 ml-1"
                        variant="primary"
                        disabled
                      >
                        <b-spinner small />
                        Report Generating ..
                      </b-button>
                    </template>

                    <template v-else>
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        class="flex-shrink-0 ml-1"
                        variant="primary"
                        type="submit">
                        Generate Payslip
                      </b-button>
                    </template>
                  </div>
                </div>
              </b-col>
            </b-row>

          </div>
        </b-form>
      </validation-observer>
    </b-card>

    <b-row>
      <b-col
        md="12"
        lg="12"
        xs="12"
      >
        <b-card-actions
          title="Filters"
          action-collapse
        >
          <b-row>
            <b-col
              v-if="$permissionAbility([SALARY_PAYSLIP_CREATE, SALARY_PAYSLIP_DISPATCH, SALARY_PAYSLIP_REVIEW, SALARY_PAYSLIP_SHOW], permissions)"
              md="4"
              lg="4"
              xs="12"
              class="col"
            >
              <v-select
                id="empId"
                v-model="filterUserId"
                name="empId"
                :options="userAllOption"
                :reduce="(item) => item.id"
                label="name"
                placeholder="Employee"
                class="mb-1 custom-font"
                @input="loadItems"
              >
                <template #option="data">
                  <UserSelect :user="data" />
                </template>
              </v-select>
            </b-col>

            <b-col
              md="4"
              lg="4"
              xs="12"
              class="col"
            >
              <b-form-group label-for="searchTerm">
                <flat-pickr
                  v-model="filterRangeDate"
                  class="form-control"
                  placeholder="Enter Date Range"
                  :config="{
                    mode: 'range',
                  }"
                  @input="loadItems"
                />
              </b-form-group>
            </b-col>

            <b-col
              v-if="$permissionAbility([SALARY_PAYSLIP_CREATE, SALARY_PAYSLIP_DISPATCH, SALARY_PAYSLIP_REVIEW, SALARY_PAYSLIP_SHOW], permissions)"
              md="4"
              lg="4"
              xs="12"
            >
              <v-select
                v-model="paySlipStatus"
                :options="paysSlipStatusOption"
                :reduce="(item) => item.value"
                label="title"
                placeholder="Select Status"
                class="mb-1 custom-font"
                @input="loadItems"
              />
            </b-col>

          </b-row>
        </b-card-actions>
      </b-col>
      <!--      <b-col-->
      <!--        md="6"-->
      <!--        lg="6"-->
      <!--        xs="12"-->
      <!--      >-->
      <!--        <b-card-actions-->
      <!--          title="Export"-->
      <!--          action-collapse-->
      <!--        >-->
      <!--          <b-row>-->

      <!--            <b-col-->
      <!--              md="6"-->
      <!--              lg="6"-->
      <!--              xs="12"-->
      <!--            >-->
      <!--              <b-form-group-->
      <!--                label-for="payslip_date"-->
      <!--                class="required-label"-->
      <!--              >-->

      <!--                <date-picker-->
      <!--                  v-model="payslipDateExcel"-->
      <!--                  type="month"-->
      <!--                  placeholder="YYYY-MM"-->
      <!--                  :editable="false"-->
      <!--                />-->

      <!--              </b-form-group>-->
      <!--            </b-col>-->

      <!--            <b-col-->
      <!--              md="6"-->
      <!--              lg="6"-->
      <!--              xs="12"-->
      <!--            >-->
      <!--              <div-->
      <!--                class="custom-search d-flex align-items-center justify-content-end"-->
      <!--              >-->
      <!--                <div-->
      <!--                  class="d-flex flex-column flex-sm-row align-items-center justify-content-around"-->
      <!--                >-->
      <!--                  <template v-if="isExcelGenerating">-->
      <!--                    <b-button-->
      <!--                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
      <!--                      class="flex-shrink-0 ml-1"-->
      <!--                      variant="success"-->
      <!--                      disabled-->
      <!--                    >-->
      <!--                      <b-spinner small />-->
      <!--                      Excel Generating ..-->
      <!--                    </b-button>-->
      <!--                  </template>-->

      <!--                  <template v-else>-->

      <!--                    <b-button-->
      <!--                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"-->
      <!--                      class="flex-shrink-0 ml-1"-->
      <!--                      variant="success"-->
      <!--                      :disabled="payslipDateExcel ? false : true"-->
      <!--                      @click="callGenerateAllExcel(payslipDateExcel)"-->
      <!--                    >-->
      <!--                      Excel-->
      <!--                    </b-button>-->
      <!--                  </template>-->

      <!--                </div>-->

      <!--              </div>-->
      <!--                  <b-button v-b-modal.excel-data-modal variant="primary" class="mt-3">-->
      <!--                    View Excel Data-->
      <!--                  </b-button>-->
      <!--            </b-col>-->
      <!--          </b-row>-->
      <!--        </b-card-actions>-->
      <!--      </b-col>-->
    </b-row>

    <b-modal
      id="excel-data-modal"
      title="Excel Data"
      :size="'xl'"
      class="full-screen-modal"
      hide-header-close
    >
      <div class="table-container">
        <b-table
          :items="excelDataForView"
          :fields="fields"
          striped
          responsive="sm"
          @row-clicked="openSidebar"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
        </b-table>
      </div>
      <template #modal-footer>
        <b-button
          variant="danger"
          @click="closeExcelDataModal"
        >
          Close
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="dispatch-modal"
      centered
      title="Disbursed Modal"
      hide-footer
      no-close-on-backdrop
      @hidden="hiddenDispatchModal"
    >
      <validation-observer ref="dispatchValidation">
        <b-form @submit.prevent="dispatchPayslip">

          <b-form-group
            label="Select Tempalte"
            label-for="template"
            class="required-label"
          >
            <validation-provider
              #default="{ errors }"
              name="template"
              vid="template"
            >
              <v-select
                v-model="selectedTemplateId"
                :options="templatesOptions"
                :reduce="(item) => item.id"
                label="name"
                placeholder="Select Template"
                class="mb-1 custom-font"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- loading button -->
          <template v-if="isDispatchSubmitLoading">
            <b-button
              class="float-right"
              variant="primary"
              disabled
            >
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <!-- submit button -->
          <template v-else>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              class="float-right"
              variant="primary"
            >
              Submit
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>

    <div>
      <b-sidebar
        id="sidebar-task-handler"
        sidebar-class="sidebar-lg"
        :visible="isPayrollHandlerSidebarActive"
        bg-variant="white"
        shadow
        backdrop
        no-header
        right
      >
        <template #default="{ hide }">
          <payslip-sidebar-content
            v-if="isPayrollHandlerSidebarActive"
            ref="payslipSidebarContent"
            :default-currency="defaultCurrency"
            :user-data="userData"
            :pay-slip-data="paySlipData"
            :is-submitting="isSubmitting"
            :is-payslip-pdf-generating="isPayslipPdfGenerating"
            :total-payable-amount="totalPayableAmount"
            @close="closeSidebar(hide)"
            @submit="payslipValidationFormModal"
            @download-pdf="downloadPayslipPDF"
            @append-form-data="appendFormData"
          />
        </template>
      </b-sidebar>
    </div>

    <b-card>
      <div>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4>Payslips</h4>
          <div
            v-if="selectedIds.length > 0"
            class="d-flex"
          >

            <v-select
              v-if="$permissionAbility([SALARY_PAYSLIP_CREATE, SALARY_PAYSLIP_DISPATCH, SALARY_PAYSLIP_REVIEW], permissions)"
              v-model="selectedStatus"
              :options="statusOptions"
              label="text"
              class="mr-2"
              placeholder="Select Status"
              :style="{ width: '230px' }"
              @input="updatePayslipStatus"
            />

            <b-button
              variant="primary"
              style="width: 250px"
              @click="exportSelectedToExcel"
            >
              <feather-icon
                icon="FileTextIcon"
                class="mr-50"
              />
              Excel View ({{ selectedIds.length }} selected)
            </b-button>
          </div>
        </div>
        <!-- table -->
        <vue-good-table
          style-class="vgt-table table-custom-style striped"
          :line-numbers="false"
          mode="remote"
          :total-rows="totalRecords"
          :is-loading.sync="isLoading"
          :rows="rows"
          :select-options="{
            enabled: $permissionAbility([SALARY_PAYSLIP_CREATE, SALARY_PAYSLIP_DISPATCH, SALARY_PAYSLIP_REVIEW, SALARY_PAYSLIP_SHOW], permissions) || false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
          }"
          :sort-options="{
            enabled: false,
            multipleColumns: true,
            initialSortBy: [
              { field: 'id', type: 'desc' },
              { field: 'created_at', type: 'desc' },
            ],
          }"
          :columns="columns"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-selected-rows-change="handleSelection"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- Column: head -->

            <span v-if="props.column.field === 'format_user'">
              <template v-if="props.row?.user_id">
                <b-link
                  :href="getPageUrl(props.row.id)"
                  @click.prevent="onShowPage(props?.row?.user?.data?.id, props?.row?.id)"
                >
                  <UserCard :user="props?.row?.user?.data" />
                </b-link>
              </template>
            </span>

            <!-- Column: Status -->
            <span v-if="props.column.field === 'status'">
              <div v-if="props?.row?.status">
                <b-badge
                  v-if="props?.row?.status"
                  variant="light-primary"
                  class="mb-1"
                >
                  {{ formatStatus(props?.row?.status) }}
                </b-badge>
                <br>
                <span>{{ formatDate(props?.row?.start_date) }} - {{ formatDate(props?.row?.end_date) }}</span>
              </div>
              <div v-else>
                <b-badge variant="light-success"> Generated </b-badge>
              </div>
            </span>

            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>

                  <b-dropdown-item
                    @click="downloadPayslipPDF(props.row.id)"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      class="mr-50"
                    />
                    <span>Download</span>
                  </b-dropdown-item>

                  <template
                    v-if="$permissionAbility(SALARY_PAYSLIP_EDIT, permissions)"
                  >
                    <b-dropdown-item
                      @click="
                        onShowPage(props?.row?.user?.data?.id, props.row.id)
                      "
                    >
                      <feather-icon
                        icon="EyeIcon"
                        class="mr-50"
                      />
                      <span>Show</span>
                    </b-dropdown-item>
                  </template>

                  <b-dropdown-item
                    v-if="$permissionAbility([SALARY_PAYSLIP_CREATE, SALARY_PAYSLIP_DISPATCH, SALARY_PAYSLIP_REVIEW, SALARY_PAYSLIP_SHOW], permissions)"
                    @click="execlView(props.row.id)"
                  >
                    <feather-icon
                      icon="FileTextIcon"
                      class="mr-50"
                    />
                    <span>Excel View</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$permissionAbility(SALARY_PAYSLIP_DELETE, permissions)"
                    @click="onDelete(props.row.id)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                    />
                    <span>Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '25', '50', '100', '500' ]"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </b-card>
  </div>

  <!-- Lead Modal -->
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BRow,
  BCol,
  BInputGroupAppend,
  BInputGroup,
  BSpinner,
  BFormDatepicker,
  BLink,
  BTable,
  BSidebar,
  BFormCheckbox,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
  email,
  max,
  mimes,
  ext,
  size,
  confirmed,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'

import {
  SALARY_PAYSLIP_CREATE,
  SALARY_PAYSLIP_SHOW,
  SALARY_PAYSLIP_DISPATCH,
  SALARY_PAYSLIP_REVIEW,
  SALARY_PAYSLIP_DELETE,
  SALARY_PAYSLIP_EDIT,
} from '@/helpers/permissionsConstant'
import { bloodGroupTypeConstants } from '@/helpers/constant/bloodGroupTypeConstant'
import { religionTypeConstants as religionValueOption } from '@/helpers/constant/religionTypeConstant'
import { maritalStatusTypeConstants as maritalStatusValueOption } from '@/helpers/constant/maritalStatusTypeConstant'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import flatPickr from 'vue-flatpickr-component'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import UserCard from '@/layouts/components/UserCard.vue'
import UserSelect from '@/layouts/components/UserSelect.vue'
import { formatDateRange } from '@/helpers/helpers'
import UserInfoCard from '@/views/admin/payroll-management/payslip/policy/UserInfoCard.vue'
import OverTimeSalaryInfo from '@/views/admin/payroll-management/payslip/policy/OverTimeSalaryInfo.vue'
import BasicSalaryInfo from '@/views/admin/payroll-management/payslip/policy/BasicSalaryInfo.vue'
import DayCountedSalaryInfo from '@/views/admin/payroll-management/payslip/policy/DayCountedSalaryInfo.vue'
import ProjectCommissionInfo from '@/views/admin/payroll-management/payslip/policy/ProjectCommissionInfo.vue'
import KPICommissionInfo from '@/views/admin/payroll-management/payslip/policy/KPICommissionInfo.vue'
import FestivalBonusInfo from '@/views/admin/payroll-management/payslip/policy/FestivalBonusInfo.vue'
import UnpaidLeaveInfo from '@/views/admin/payroll-management/payslip/policy/UnpaidLeaveInfo.vue'
import OthersFine from '@/views/admin/payroll-management/payslip/policy/OthersFine.vue'
import LateFineInfo from '@/views/admin/payroll-management/payslip/policy/LateFineInfo.vue'
import MealInfo from '@/views/admin/payroll-management/payslip/policy/MealInfo.vue'
import InsuranceInfo from '@/views/admin/payroll-management/payslip/policy/InsuranceInfo.vue'
import ProvidentFundInfo from '@/views/admin/payroll-management/payslip/policy/ProvidentFundInfo.vue'
import IncomeTaxInfo from '@/views/admin/payroll-management/payslip/policy/IncomeTaxInfo.vue'
import ExtraLeaveInfo from '@/views/admin/payroll-management/payslip/policy/ExtraLeaveInfo.vue'
import LoanInfo from '@/views/admin/payroll-management/payslip/policy/LoanInfo.vue'
import { yearConstants } from '@/helpers/constant/yearConstant'
import Swal from 'sweetalert2'

const PayslipSidebarContent = () => import('@/views/admin/payroll-management/payslip/PayslipSidebarContent.vue')
export default {
  name: 'UsersView',
  components: {
    BFormCheckbox,
    UserSelect,
    BCardActions,
    flatPickr,
    BRow,
    BCol,
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    UserCard,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BInputGroupAppend,
    BInputGroup,
    BSpinner,
    BFormDatepicker,
    BLink,
    DatePicker,
    BTable,
    BSidebar,
    DayCountedSalaryInfo,
    IncomeTaxInfo,
    InsuranceInfo,
    ProvidentFundInfo,
    MealInfo,
    LoanInfo,
    LateFineInfo,
    OthersFine,
    UnpaidLeaveInfo,
    FestivalBonusInfo,
    KPICommissionInfo,
    ProjectCommissionInfo,
    BasicSalaryInfo,
    OverTimeSalaryInfo,
    UserInfoCard,
    ExtraLeaveInfo,
    PayslipSidebarContent,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {

      isDispatchSubmitLoading: false,
      fields: [
        { key: 'index', label: '#' },
        { key: 'name', label: 'Name' },
        { key: 'basic', label: 'Basic' },
        { key: 'house_rent_allowance', label: 'House Rent Allowance (HRA)' },
        { key: 'conveyance_allowance', label: 'Conveyance Allowance (CA)' },
        { key: 'medical_allowance', label: 'Medical Allowance (MA)' },
        { key: 'dearness_allowance', label: 'Dearness Allowance (DA)' },
        { key: 'gross_salary', label: 'Gross Salary' },
        { key: 'day_counted_salary', label: 'Day Counted Salary' },
        { key: 'overtime_wages', label: 'Overtime Wages' },
        { key: 'festival_bonus', label: 'Festival Bonus' },
        { key: 'project_commission', label: 'Project Commission' },
        { key: 'kpi_bonus', label: 'KPI Bonus' },
        { key: 'loan_disbursement', label: 'Loan Disbursement' },
        { key: 'salary_advance', label: 'Salary Advance' },
        { key: 'unpaid_leave', label: 'Unpaid Leave' },
        { key: 'late_entry_fine', label: 'Late Entry Fine' },
        { key: 'extra_leave_fine', label: 'Extra Leave Fine' },
        { key: 'others_fine', label: 'Others Fine' },
        { key: 'employee_contribution_insurance', label: 'Employee Contribution to Insurance' },
        { key: 'employee_contribution_pf', label: 'Employee Contribution to PF' },
        { key: 'tax_deduction', label: 'Tax Deduction' },
        { key: 'loan_repayment', label: 'Loan Repayment' },
        { key: 'meal_deduction', label: 'Meal Deduction' },
        { key: 'net_payable_salary', label: 'Net Payable Salary' },
        { key: 'meal_allowance', label: 'Meal Allowance' },
        { key: 'employer_contribution_insurance', label: 'Employer Contribution to Insurance' },
        { key: 'employer_contribution_pf', label: 'Employer Contribution to PF' },
        { key: 'ctc', label: 'CTC' },
      ],
      isSidebarRight: false,
      isPayrollHandlerSidebarActive: false,
      defaultCurrency: '',
      paySlipData: {},
      userData: {},
      isSubmitting: false,
      totalPayableAmount: 0,
      yearConstants,
      formData: {
        currency: '',
        overtime_remarks: '',
        overtime_manual_amount: 0,
        overtime_is_policy: true,
        overtime_policy_id: '',

        meal_remarks: '',
        meal_amount: 0,
        meal_manual_amount: 0,
        meal_is_policy: true,
        meal_policy_id: '',

        late_fine_remarks: '',
        late_fine_manual_amount: 0,
        late_fine_is_policy: true,
        late_fine_policies_id: [],

        unpaid_leave_remarks: '',
        unpaid_leave_manual_amount: 0,
        unpaid_leave_is_manual: false,

        extra_leave_remarks: '',
        extra_leave_manual_amount: 0,
        extra_leave_is_manual: false,

        project_commission_remarks: '',
        project_commission_manual_amount: 0,
        project_commission_is_policy: true,
        project_commission_policy_id: '',
        milestone_id: [],

        festival_bonus_policies: [],
        fine_policies: [],
        kpi_amount: 0,
        income_tax_amount: 0,
      },
      isPayslipPdfGenerating: false,

      SALARY_PAYSLIP_CREATE,
      SALARY_PAYSLIP_SHOW,
      SALARY_PAYSLIP_DELETE,
      SALARY_PAYSLIP_DISPATCH,
      SALARY_PAYSLIP_REVIEW,
      SALARY_PAYSLIP_EDIT,

      filterRangeDate: '',
      filterStartDate: '',
      filterEndDate: '',

      year: '',
      filterDepartmentIdOption: [],
      selectDepartmentId: '',
      filterEmpIdOption: [],
      selectEmpId: 'All',
      payslipDateInput: '',
      payslipDateExcel: '',

      // pay slip
      startDate: null,
      endDate: null,
      payslipDate: null,
      payslipStartDateInput: null,
      payslipEndDateInput: null,
      isReportGenerating: false,
      isExcelGenerating: false,

      paysSlipStatusOption: [
        { title: 'All', value: 'all' },
        { title: 'Initially Generated', value: 'initially generated' },
        { title: 'Under Review', value: 'under review' },
        { title: 'Reviewed', value: 'reviewed' },
        { title: 'Disbursed', value: 'disbursed' },
      ],
      paySlipStatus: '',
      userId: '',
      filterUserId: '',
      userIdOption: [],
      userAllOption: [],

      recurringPolicyId: '',
      recurringPolicyOption: [],

      recurringPolicyCycleId: '',
      recurringPolicyCycleOption: [],

      modelType: '',
      imageSizeError: '',
      avatar: null,
      name: '',
      nid: '',
      employeeNumber: '',
      machineEmployeeId: '',
      password: '',
      password_confirmation: '',
      email: '',
      mobile: '',
      dob: '',
      salary: '',
      selectBloodGroupValue: '',
      bloodGroupTypeConstants,
      selectReligionValue: '',
      religionValueOption,
      selectMaritalStatusValue: '',
      maritalStatusValueOption,
      joinDate: '',
      selectRoleId: '',
      roleIdOption: [],
      selectGenderId: '',
      previewAvatar: null,
      selectStatusValue: true,
      statusValueOption: [
        {
          name: 'Active',
          value: true,
        },
        {
          name: 'Inactive',
          value: false,
        },
      ],
      selectDesignationId: '',
      designationIdOption: [],
      selectEmployeeTypesId: '',
      employeeTypesOption: [],
      selectLeaveTypesIds: [],
      leaveTypesOption: [],
      departmentIdOption: [],
      pageLength: 10,

      columns: [
        {
          label: 'Name',
          field: 'format_user',
          sortable: false,
        },
        {
          label: 'Department',
          field: 'user.data.department.data.name',
          sortable: false,
        },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
      ],

      cellStyle: {
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },

      excelData: [],

      rows: [],
      searchTerm: '',
      delayTimer: null,
      isLoading: false,
      isUserFormSubmitLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          { field: 'id', type: 'desc' },
          { field: 'created_at', type: 'desc' },
        ],
        page: 1,
        perPage: 10,
      },
      excelDataForView: [],
      previousSelectedRows: [],
      excelViewSingleId: null,
      selectedIds: [],
      selectedStatus: null,
      StoreStatusOptions: [
        { value: 'initially generated', text: 'Initially Generated' },
        { value: 'under review', text: 'Under Review' },
        { value: 'reviewed', text: 'Reviewed' },
        { value: 'disbursed', text: 'Disbursed' },
      ],

      statusOptions: [],

      templatesOptions: [],
      selectedTemplateId: '',
    }
  },

  computed: {
    ...mapGetters({
      user: 'userModule/getUser',
      permissions: 'userModule/getPermissions',
    }),

    statusVariant() {
      const statusColor = {
        true: 'light-success',
        false: 'light-danger',
      }

      return status => statusColor[status]
    },
  },

  async created() {
    try {
      const users = await this.getActiveUsers()
      const allUsers = await this.getAllUsers()
      const departments = await this.getDepartments()
      const templates = await this.getSlipTemplates()

      this.templatesOptions = templates?.data?.data

      const defaultId = templates?.data?.meta?.default_id
      if (defaultId) {
        this.selectedTemplateId = defaultId
      }
      this.userIdOption = (users?.data?.data || []).map(item => ({
        avatar: item?.avatar,
        name: item?.name,
        email: item?.email,
        mobile: item?.mobile,
        employee_number: item?.employee_number,
        id: item?.id,
        departmentId: item?.department_id,
      }))

      this.userAllOption = (allUsers?.data?.data || []).map(item => ({
        avatar: item?.avatar,
        name: item?.name,
        email: item?.email,
        mobile: item?.mobile,
        employee_number: item?.employee_number,
        id: item?.id,
        departmentId: item?.department_id,
      }))

      this.filterDepartmentIdOption = (departments?.data?.data || []).map(
        item => {
          const name = item?.name

          return {
            name,
            divisionId: item?.division_id,
            id: item?.id,
          }
        },
      )

      if (this.$permissionAbility(SALARY_PAYSLIP_CREATE, this.permissions)) {
        this.statusOptions.push({ value: 'under review', text: 'Under Review' })
      }

      if (this.$permissionAbility(SALARY_PAYSLIP_REVIEW, this.permissions)) {
        this.statusOptions.push({ value: 'reviewed', text: 'Reviewed' })
      }

      if (this.$permissionAbility(SALARY_PAYSLIP_DISPATCH, this.permissions)) {
        this.statusOptions.push({ value: 'disbursed', text: 'Disbursed' })
      }
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'BellIcon',
          variant: 'danger',
          text: error?.response?.data?.message,
        },
      })
    }
  },
  methods: {

    hiddenDispatchModal() {
      this.resetModal()
      this.$bvModal.hide('dispatch-modal')
      this.loadItems()
    },

    async dispatchPayslip() {
      this.$refs.dispatchValidation.validate().then(async success => {
        if (success) {
          try {
            const response = await this.$api.put('/api/payroll/status',
              {
                payslip_ids: this.selectedIds,
                status: this.selectedStatus.value,
                templateId: this.selectedTemplateId,
              },
              {
                responseType: 'blob',
              })

            await this.saveFile(response.data)
            this.hiddenDispatchModal()

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Payslip Status Successfully updated',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'BellIcon',
                variant: 'danger',
                text: error?.response?.data?.message,
              },
            })
          }
        }
      })
    },
    async updatePayslipStatus() {
      this.$swal({
        title: 'Warning!',
        text: 'Are You Sure You Want To Change the status?',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        showLoaderOnConfirm: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            if (this.selectedStatus.value === 'disbursed') {
              this.$bvModal.show('dispatch-modal')
              return
            }

            await this.$api.put('/api/payroll/status',
              {
                payslip_ids: this.selectedIds,
                status: this.selectedStatus.value,
              })

            await this.loadItems()
            this.resetModal()

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Payslip Status Successfully updated',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'BellIcon',
                variant: 'danger',
                text: error?.response?.data?.message,
              },
            })
          }
        }
      })
    },
    saveFile(file) {
      const blob = new Blob([file], { type: 'application/pdf' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'payslip-bank-statement.pdf'
      link.click()
    },
    closeExcelDataModal() {
this.$bvModal.hide('excel-data-modal')
      this.excelViewSingleId = null
    },

    formatStatus(status) {
      if (!status) return ''
      return status.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
    },

    exportSelectedToExcel() {
      this.getAllExcelViewData(null, 'mulipleRow', this.selectedIds)
      this.$bvModal.show('excel-data-modal')
    },
    handleSelection(params) {
      const newlySelected = params.selectedRows.filter(
        row => !this.previousSelectedRows.some(prevRow => prevRow.id === row.id),
      )

      const newlyDeselected = this.previousSelectedRows.filter(
        prevRow => !params.selectedRows.some(row => row.id === prevRow.id),
      )

      newlySelected.forEach(row => {
        if (!this.selectedIds.includes(row.id)) {
          this.selectedIds.push(row.id)
        }
      })

      newlyDeselected.forEach(row => {
        const index = this.selectedIds.indexOf(row.id)
        if (index > -1) {
          this.selectedIds.splice(index, 1)
        }
      })

      this.previousSelectedRows = [...params.selectedRows]
    },

    execlView(id) {
      this.$bvModal.show('excel-data-modal')
      this.excelViewSingleId = id
      this.getAllExcelViewData(this.excelViewSingleId)
    },
    async getAllExcelViewData(id = null, callingType = 'singleRow', ids = []) {
      try {
        const data = await this.$api.post('/api/payroll/user/payslip-excel-view-report-data', {
          id,
          callingType,
          ids,
        })

        this.excelDataForView = data?.data?.data
      } catch (error) {
        console.log('error:', error)
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'BellIcon',
              variant: 'danger',
              text: error?.response?.data?.message,
            },
          })
        }
      }
    },
    generateDemoData() {
      return [
        {
          name: 'John Doe',
          basic: 50000,
          house_rent_allowance: 20000,
          conveyance_allowance: 5000,
          medical_allowance: 3000,
          dearness_allowance: 1000,
          gross_salary: 79000,
          day_counted_salary: 79000,
          overtime_wages: 0,
          festival_bonus: 0,
          project_commission: 0,
          kpi_bonus: 0,
          loan_disbursement: 0,
          salary_advance: 0,
          unpaid_leave: 0,
          late_entry_fine: 0,
          extra_leave_fine: 0,
          others_fine: 0,
          employee_contribution_insurance: 1000,
          employee_contribution_pf: 2000,
          tax_deduction: 5000,
          loan_repayment: 0,
          meal_deduction: 0,
          net_payable_salary: 71000,
          meal_allowance: 0,
          employer_contribution_insurance: 1000,
          employer_contribution_pf: 2000,
          ctc: 84000,
        },
        {
          name: 'Jack Mac',
          basic: 50000,
          house_rent_allowance: 20000,
          conveyance_allowance: 5000,
          medical_allowance: 3000,
          dearness_allowance: 1000,
          gross_salary: 79000,
          day_counted_salary: 79000,
          overtime_wages: 0,
          festival_bonus: 0,
          project_commission: 0,
          kpi_bonus: 0,
          loan_disbursement: 0,
          salary_advance: 0,
          unpaid_leave: 0,
          late_entry_fine: 0,
          extra_leave_fine: 0,
          others_fine: 0,
          employee_contribution_insurance: 1000,
          employee_contribution_pf: 2000,
          tax_deduction: 5000,
          loan_repayment: 0,
          meal_deduction: 0,
          net_payable_salary: 71000,
          meal_allowance: 0,
          employer_contribution_insurance: 1000,
          employer_contribution_pf: 2000,
          ctc: 84000,
        },
        {
          name: 'Mark Joker',
          basic: 50000,
          house_rent_allowance: 20000,
          conveyance_allowance: 5000,
          medical_allowance: 3000,
          dearness_allowance: 1000,
          gross_salary: 79000,
          day_counted_salary: 79000,
          overtime_wages: 0,
          festival_bonus: 0,
          project_commission: 0,
          kpi_bonus: 0,
          loan_disbursement: 0,
          salary_advance: 0,
          unpaid_leave: 0,
          late_entry_fine: 0,
          extra_leave_fine: 0,
          others_fine: 0,
          employee_contribution_insurance: 1000,
          employee_contribution_pf: 2000,
          tax_deduction: 5000,
          loan_repayment: 0,
          meal_deduction: 0,
          net_payable_salary: 71000,
          meal_allowance: 0,
          employer_contribution_insurance: 1000,
          employer_contribution_pf: 2000,
          ctc: 84000,
        },
        // Add more demo data as needed
      ]
    },
    appendFormData(field, value) {
      this.formData[field] = value
    },
    async openSidebar(row) {
      if (!this.$permissionAbility(SALARY_PAYSLIP_EDIT, this.permissions)) {
        return
      }

      this.$bvModal.hide('excel-data-modal')
      const [paySlipInfo, settings] = await Promise.all([
        this.getPayslipItems(row.id),
        this.getSetting(),
      ])
      this.paySlipData = paySlipInfo?.data?.data
      this.totalPayableAmount = this.paySlipData?.total_payable_amount
      this.defaultCurrency = settings.data.data.currency.currency
      this.formData.currency = this.defaultCurrency

      const userInfo = await this.getUser(row.user_id)
      this.userData = userInfo?.data?.data
      this.isPayrollHandlerSidebarActive = true
    },
    async payslipValidationFormModal() {
      const sidebarContent = this.$refs.payslipSidebarContent

      if (!sidebarContent) {
        console.error('Sidebar content ref not found')
        return
      }

      const isValid = await sidebarContent.validateForm()

      if (isValid) {
        try {
          await sidebarContent.resetValidation()
          this.isSubmitting = true

          await this.$api.put(
            `api/payroll/user/${this.userData.id}/payslip/${this.paySlipData.id}/generate`,
            {
              id: this.paySlipData.id,
              ...this.formData,
            },
          )

          this.isSubmitting = false
          if (this.excelViewSingleId !== null) {
            this.getAllExcelViewData(this.excelViewSingleId)
          }

          if (this.selectedIds.length > 0) {
            this.getAllExcelViewData(null, 'mulipleRow', this.selectedIds)
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'BellIcon',
              variant: 'success',
              text: 'Payslip submitted successfully',
            },
          })

          await this.loadItems()
        } catch (error) {
          this.isSubmitting = false
          console.error('Error:', error)

          if (error?.response?.data?.message) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'BellIcon',
                variant: 'danger',
                text: error.response.data.message,
              },
            })
          }

          if (error?.response?.data?.errors) {
            sidebarContent.setValidationErrors(error.response.data.errors)
          }
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: 'Please check your input',
          },
        })
      }
    },
    async downloadPayslipPDF(id = null) {
      this.isPayslipPdfGenerating = true

      const response = await this.$api.get('api/payroll/report/payslip', {
        responseType: 'blob',
        params: {
          payslip_id: id || this.paySlipData?.id,
        },
      })

      await this.saveFile(response.data)

      this.isPayslipPdfGenerating = false

      this.loadItems()
    },
    async getPayslipItems(id) {
      return this.$api.get(
        `api/payroll/payslip/${id}`,
      )
    },
    async getUser(id) {
      return this.$api.get(
        `api/users/${id}?include=department`,
      )
    },
    async getSetting() {
      return this.$api.get('/api/settings?includes=currency')
    },
    closeSidebar(hide) {
      this.$bvModal.show('excel-data-modal')
      this.isPayrollHandlerSidebarActive = false // Close sidebar
      hide() // Call the hide function to close the modal if needed
    },

    async changeDepartment() {
      this.selectEmpId = ''
      const employees = await this.getActiveUsers()

      const employeeData = (employees?.data?.data || []).map(item => ({
        avatar: item?.avatar,
        name: item?.name,
        email: item?.email,
        mobile: item?.mobile,
        employee_number: item?.employee_number,
        id: item?.id,
        departmentId: item?.department_id,
      }))

      if (this.selectDepartmentId) {
        this.userIdOption = employeeData

        this.userIdOption = this.userIdOption.filter(
          item => item?.departmentId === this.selectDepartmentId,
        )
      } else {
        this.userIdOption = employeeData
      }
    },
    async getDepartments() {
      return this.$api.get('api/departments/all')
    },

    async getSlipTemplates() {
      return this.$api.get('api/bank-slip-template/all')
    },

    async getPolicy() {
      return this.$api.get('api/recurring-policies/all')
    },
    async generateAllReport() {
      try {
        this.isLoading = true

        const payslip = await this.$api.post('/api/payroll/user/payslip-initially-generate', {
          user_id: (this.selectEmpId && this.selectEmpId !== 'All') ? this.selectEmpId : '',
          dept_id: this.selectDepartmentId
        })
        this.isLoading = false

        if(!payslip?.data?.success)
        {
          const userListHtml = payslip?.data?.users
              .map(user => `<li><strong>${user.name}</strong> (${user.email})</li>`)
              .join('');
          this.$swal({
            title: 'Payslip Generation Failed for Overlapping Date',
            html: `<ul style="text-align:left;">${userListHtml}</ul>`,
            icon: 'info',
            confirmButtonText: 'Close',
          });
        }

        await this.loadItems()
      } catch (error) {
        this.isLoading = false

        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'BellIcon',
              variant: 'danger',
              text: error?.response?.data?.message,
            },
          })
        }

        if (error?.response?.data?.errors) {
          this.$refs.payslipValidation.setErrors(error?.response?.data?.errors)
        }
      }
    },

    async callGenerateAllExcel(dateData) {
      this.isExcelGenerating = true

      const forExcel = true
      await this.changePayslipDate(dateData, forExcel)

      await this.generateAllExcel().catch(error => {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'BellIcon',
              variant: 'danger',
              text: error?.response?.data?.message,
            },
          })
        }
      })

      this.isExcelGenerating = false
    },

    async generateAllExcel() {
      try {
        const data = await this.$api.post('/api/payroll/user/payslip-excel-report-data', {
          payslip_date: this.payslipDateExcel,
        })

        window.location.href = data?.data?.data
        this.excelData = []
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'BellIcon',
              variant: 'danger',
              text: error?.response?.data?.message,
            },
          })
        }

        if (error?.response?.data?.errors) {
          this.$refs.payslipValidation.setErrors(error?.response?.data?.errors)
        }
      }
    },
    async onDelete(id) {
      this.$swal({
        title: 'Warning!',
        text: 'Are You Sure You Want To Delete This?',
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        showLoaderOnConfirm: true,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            await this.$api.delete(`/api/payroll/payslip/${id}`)

            await this.loadItems()

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'BellIcon',
                variant: 'success',
                text: 'Payslip Successfully Deleted',
              },
            })
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'BellIcon',
                variant: 'danger',
                text: error?.response?.data?.message,
              },
            })
          }
        }
      })
    },
    handleDateRangeChange() {
      if (this.filterRangeDate && this.filterRangeDate !== '') {
        const dates = this.filterRangeDate.split(' to ')

        if (dates.length === 1) {
          // Case where only one date is provided
          this.filterStartDate = dates[0]
          this.filterEndDate = dates[0]
        } else if (dates.length === 2) {
          // Case where both start and end dates are provided
          this.filterStartDate = dates[0]
          this.filterEndDate = dates[1]
        } else {
          // Handle invalid date range format
          console.error('Invalid date range format')
          // You can choose to handle this case differently based on your requirements
        }
      }
    },
    async getActiveUsers() {
      return this.$api.get('api/users/active-all')
    },

    async getAllUsers() {
      return this.$api.get('api/users/active-all')
    },
    resetModal() {
      this.payslip_ids = ''
      this.templateId = ''
      this.selectedTemplateId = ''
      this.selectedStatus = ''
    },
    changePayslipDate(dateData, forExcel) {
      const payslipDate = new Date(dateData)

      const year = payslipDate.getFullYear()
      const month = String(payslipDate.getMonth() + 1).padStart(2, '0')
      const day = String(payslipDate.getDate()).padStart(2, '0')

      const formattedStartDate = `${year}-${month}-${day}`

      if (forExcel) {
        this.payslipDateExcel = formattedStartDate
      } else {
        this.payslipDateInput = formattedStartDate
      }
    },
    changeStartDate() {
      if (this.startDate) {
        const startDate = new Date(this.startDate)

        const year = startDate.getFullYear()
        const month = String(startDate.getMonth() + 1).padStart(2, '0')
        const day = String(startDate.getDate()).padStart(2, '0')

        const formattedStartDate = `${year}-${month}-${day}`

        this.payslipStartDateInput = formattedStartDate
      } else {
        this.payslipStartDateInput = null
      }

      this.loadItems()
    },
    changeEndDate() {
      if (this.endDate) {
        const endDate = new Date(this.endDate)

        const year = endDate.getFullYear()
        const month = endDate.getMonth() + 1
        const lastDay = new Date(year, month, 0)

        const formattedLastDate = `${year}-${String(month).padStart(
          2,
          '0',
        )}-${String(lastDay.getDate()).padStart(2, '0')}`

        this.payslipEndDateInput = formattedLastDate
      } else {
        this.payslipEndDateInput = null
      }

      this.loadItems()
    },
    filterPayslip() {
      this.loadItems()
    },
    getPageUrl(userId, id) {
      return this.$router.resolve({ name: 'admin-salary-payslip-details-dev', params: { userId, id } }).href
    },
    async onShowPage(userId, id) {
      try {
        await this.$router.push({
          name: 'admin-salary-payslip-details-dev',
          params: {
            userId,
            id
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: error?.response?.data?.message,
          },
        })
      }
    },
    onContextPurchaseDate(ctx) {
      this.purchaseDate = ctx.selectedYMD
    },
    roleName(rowObj) {
      return rowObj?.roles?.data[0]?.name
    },
    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer)
        this.delayTimer = null
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems()
      }, 1000)
    },

    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },

    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    async getPayslips(params) {
      return await this.$api.get(
        'api/payroll/payslip?include=user.department,user.designation',
        {
          params: {
            show: params.show,
            page: params.page,
            sort: params.sort,
            userId: params.userId,
            startDate: params.startDate,
            endDate: params.endDate,
            paySlipStatus: params.paySlipStatus,
          },
        },
      )
    },

    async loadItems() {
      try {
        this.handleDateRangeChange()

        const [payslips] = await Promise.all([
          this.getPayslips({
            show: this.serverParams.perPage,
            page: this.serverParams.page,
            sort: this.serverParams.sort,
            userId: this.filterUserId,
            startDate: this.filterStartDate,
            endDate: this.filterEndDate,
            paySlipStatus: this.paySlipStatus,
          }),
        ])

        const data = payslips?.data?.data
        const meta = payslips?.data?.meta

        this.totalRecords = meta?.pagination?.total

        this.rows = data
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: error?.response?.data?.message,
          },
        })
      }
    },

    async payslipValidationForm() {
      this.$refs.payslipValidation.validate().then(async success => {
        if (success) {
          try {
            this.$refs.payslipValidation.reset()
            this.isLoading = true

            await this.$api.post(
              '/api/payroll/user/payslip-initially-generate',
              {
                responseType: 'blob',
                params: {
                  user_id: this.userId,
                  payslip_date: this.payslipDateInput,
                },
              },
            )
            this.isLoading = false
            this.hiddenModal()
            this.loadItems()
          } catch (error) {
            this.isLoading = false

            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error',
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: error?.response?.data?.message,
                },
              })
            }

            if (error?.response?.data?.errors) {
              this.$refs.payslipValidation.setErrors(
                error?.response?.data?.errors,
              )
            }
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
.custom-font {
  font-size: 13px !important;
}
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.required-label label::after {
  content: " *";
  color: red;
}
.mx-datepicker {
  width: 100%;
}

.table-custom-style {
  font-size: 14px !important;
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: middle !important;
  }
}
.custom-font {
  font-size: 13px !important;
}
.custom-font-validation {
  font-size: 11px;
}
.cell-with-description div {
  margin: 2px 0px;
}

/* Adjust the modal layout */
.full-screen-modal .modal-dialog {
  max-width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.full-screen-modal .modal-content {
  height: 100%;
  border-radius: 0;
}

/* Make the modal body scrollable */
.full-screen-modal .modal-body {
  padding: 0;
  height: calc(100% - 56px); /* Adjust based on modal header/footer height */
  overflow-y: auto;
}

/* Make the table container scrollable */
.table-container {
  max-height: 500px; /* Adjust this based on your modal size */
  overflow-y: auto;
}

/* Ensure the table itself is scrollable */
.b-table {
  border-collapse: collapse; /* Remove double borders */
  width: 100%;
}

.b-table th,
.b-table td {
  border: 1px solid #ddd !important; /* Light gray border */
  text-align: center; /* Center text for better readability */
  padding: 8px; /* Padding for better spacing */
}

/* Style table header */
.b-table thead th {
  background-color: #f8f9fa; /* Light background for header */
  font-weight: bold;
  border: 1px solid #aaa !important;
}

.b-sidebar-outer{
  z-index: 1051;
}

/* Custom width for the sidebar */
.b-sidebar.sidebar-lg {
  width: 90rem !important;
}
</style>
